document.addEventListener("alpine:init", () => {
  Alpine.store("cart", {
    open: false,
    loading: false,
    error: null,
    count: 0,
    total_price: 0,

    money(cents) {
      const c = Shopify?.currency?.active || "USD";
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: c,
      }).format((cents || 0) / 100);
    },

    get cartTotal() {
      return this.total_price;
    },

    quantityFor({ line }) {
      const el = document.querySelector(
        `[data-line="${line}"] input[type="number"]`
      );
      return el ? +el.value : 0;
    },

    async fetchCart() {
      try {
        const r = await fetch("/cart.js");
        const cart = await r.json();
        this.count = cart.item_count;
        this.total_price = cart.total_price;

        const badge = document.querySelector("[data-cart-count]");
        if (badge) badge.textContent = this.count;
      } catch {
        this.error = "Failed to load cart.";
      }
    },

    _drawerSectionId() {
      return (
        document.getElementById("CartDrawer")?.dataset.sectionId ||
        "cart-drawer"
      );
    },

    async refreshSections({ refreshHeader = true } = {}) {
      this.loading = true;
      try {
        const drawerId = this._drawerSectionId();
        const targets = refreshHeader ? `${drawerId},header` : drawerId;
        const res = await fetch(`/?sections=${targets}`);
        const html = await res.json();

        const wrap = document.createElement("div");
        wrap.innerHTML = html[drawerId] || "";
        const freshInner = wrap.querySelector("#CartDrawerInner");
        if (freshInner) {
          const current = document.getElementById("CartDrawerInner");
          if (current) {
            // Replace innerHTML
            current.innerHTML = freshInner.innerHTML;

            // Re-bind all cart remove/change buttons manually
            current.querySelectorAll('[data-line]').forEach(item => {
              const line = parseInt(item.dataset.line);

              // Remove button
              const removeBtn = item.querySelector('.remove-item');
              if (removeBtn) {
                const newBtn = removeBtn.cloneNode(true);
                removeBtn.replaceWith(newBtn);
                newBtn.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  Alpine.store('cart').remove({ line });
                });
              }

              // Minus button
              const qtyBtns = item.querySelectorAll('.cart-drawer__qty button');
              if (qtyBtns.length >= 2) {
                const currentQty = parseInt(item.querySelector('.cart-drawer__qty span')?.textContent || '1');

                // Minus
                const minusBtn = qtyBtns[0];
                const newMinus = minusBtn.cloneNode(true);
                minusBtn.replaceWith(newMinus);
                newMinus.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  Alpine.store('cart').change({ line, qty: Math.max(0, currentQty - 1) });
                });

                // Plus
                const plusBtn = qtyBtns[1];
                const newPlus = plusBtn.cloneNode(true);
                plusBtn.replaceWith(newPlus);
                newPlus.addEventListener('click', (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  Alpine.store('cart').change({ line, qty: currentQty + 1 });
                });
              }
            });
          }

          // Re-initialize Swiper after AJAX update
          setTimeout(function() {
            var selector = ".swiper-recommendation";
            if (window.Swiper && document.querySelector(selector)) {
              new Swiper(selector, {
                slidesPerView: 3,
                spaceBetween: 7,
                rewind: true,
                navigation: {
                  nextEl: ".recommendations .slider-next",
                  prevEl: ".recommendations .slider-prev",
                },
              });
            }
          }, 100);
        }

        // Also update header badge
        if (refreshHeader && html["header"]) {
          const headerWrap = document.createElement("div");
          headerWrap.innerHTML = html["header"] || "";
          const newBadge = headerWrap.querySelector("[data-cart-count]");
          const currentBadge = document.querySelector("[data-cart-count]");
          if (newBadge && currentBadge) {
            currentBadge.textContent = newBadge.textContent;
          }
        }

        await this.fetchCart();
      } catch (e) {
        console.error('refreshSections error:', e);
      } finally {
        this.loading = false;
      }
    },

    async add({ id, quantity = 1, properties = {}, selling_plan = null }) {
      this.loading = true;
      try {
        let r;
        if (selling_plan) {
          // Selling plans require URL-encoded format
          let body = `id=${id}&quantity=${quantity}&selling_plan=${selling_plan}`;
          // Include line-item properties if any
          if (properties && typeof properties === 'object') {
            Object.keys(properties).forEach(k => {
              body += `&properties[${encodeURIComponent(k)}]=${encodeURIComponent(properties[k])}`;
            });
          }
          r = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body,
          });
        } else {
          // Standard JSON format for one-time purchases
          r = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ items: [{ id, quantity, properties }] }),
          });
        }
        if (!r.ok) throw await r.json();
        await this.refreshSections();
        this.openDrawer();
      } catch (e) {
        console.error('Cart add error:', e);
        this.error = e?.description || "We were unable to add the product.";
      } finally {
        this.loading = false;
      }
    },

    async addMultiple({ items }) {
      // items: [{ id, quantity, selling_plan?, properties? }, ...]
      // Shopify /cart/add.js accepts items array with per-item selling_plan
      if (!Array.isArray(items) || items.length === 0) return;
      if (items.length === 1) return this.add(items[0]);

      this.loading = true;
      try {
        const r = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ items }),
        });
        if (!r.ok) throw await r.json();
        await this.refreshSections();
        this.openDrawer();
      } catch (e) {
        console.error('Cart addMultiple error:', e);
        this.error = e?.description || "We were unable to add the products.";
      } finally {
        this.loading = false;
      }
    },

    async change({ line, qty }) {
      this.loading = true;
      try {
        const r = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line, quantity: qty }),
        });
        if (!r.ok) throw await r.json();
        await this.refreshSections();
      } catch (e) {
        console.error('Cart change error:', e);
        this.error = "Could not update quantity.";
      } finally {
        this.loading = false;
      }
    },

    async remove({ line }) {
      return this.change({ line, qty: 0 });
    },

    refresh() {
      return this.refreshSections();
    },

    openDrawer() {
      this.open = true;
      this.refreshSections();
    },
    closeDrawer() {
      this.open = false;
    },
  });

  Alpine.data("cartDrawer", () => ({
    get open() {
      return Alpine.store("cart").open;
    },
    set open(v) {
      Alpine.store("cart").open = v;
    },
    get cartTotal() {
      return Alpine.store("cart").cartTotal;
    },
    money: (cents) => Alpine.store("cart").money(cents),

    init() {
      Alpine.store("cart").fetchCart();
      this.$watch("open", (o) => {
        if (o) document.addEventListener("keydown", this._esc);
        else document.removeEventListener("keydown", this._esc);
      });

      function initSwiperRecommendation() {
        var selector = ".swiper-recommendation";
        if (window.Swiper && document.querySelector(selector)) {
          new Swiper(selector, {
            slidesPerView: 3,
            spaceBetween: 7,
            rewind: true,
          });
        }
      }
      initSwiperRecommendation();
    },
    _esc(e) {
      if (e.key === "Escape") Alpine.store("cart").closeDrawer();
    },
    close() {
      Alpine.store("cart").closeDrawer();
    },
  }));
});
